<template>
  <el-row>
    <!--类型值：{{sys_code_value}}-->

    <el-select v-model="sys_code_value"
               :placeholder="sys_code_placeholder"
               size="mini"
               :style="sys_code_style"
               :multiple="sys_code_multiple"
               @change="change"
               filterable
               :disabled="disabled_text"
               :clearable="is_clearable"

    >
      <el-option
        v-if="!sys_code_multiple && sys_code_has_all"
        :label="default_label_name"
        value=""
      >

      </el-option>
      <el-option
         v-loading="sys_code_loading"
        v-for="item in options"
        :key="item.sys_code"
        :label="item.sys_code_text"
        :value="item.sys_code"
        :disabled="item.disabled"

      >
<!--        <i :class="item.property_1"></i>-->
        <sys_code_icon_show :icon="item.property_1" :class="{'mask-class': item.disabled}"></sys_code_icon_show>
        <span>{{item.sys_code_text}}</span>
      </el-option>
    </el-select>
  </el-row>
</template>
<script type="text/javascript">
    import * as API from "@/api/index.js"
    import Sys_code_icon_show from "@/components/common_page/sys_code_icon_show";

    export default {
      components:{
        Sys_code_icon_show
      },
        props: {
            sys_code_style: {//选择器样式
                type: Object,
                default: function () {
                    return {"width": "100%"}
                }
            },
            sys_code_type: {//类型
                type: String,
                default: ""
            },
            sys_code_multiple: {//是否多选
                type: Boolean,
                default: false
            },
            sys_code_has_all: {//是否有全部选项
                type: Boolean,
                default: true
            },
            excude_list: {//排除列表，编码以逗号分割
                type: String,
                default: ""
            },
            disabled_list: {//禁用列表，编码以逗号分割
                type: String,
                default: ""
            },
            sys_code_placeholder: {//提示文字
                type: String,
                default: "请选择"

            },
            disabled_text: {
                type: Boolean,
                default: false
            },
            // default_value:{
            // 	type:String,
            // 	default:""
            // },
            default_label_name: {
                type: String,
                default: "全部"
            },
            data_value: {
                type: String,
                default: ""
            },
          sys_code_list:{
              type:Array,
              default:function () {
                return null
              }
          },

          is_clearable:{
             type: Boolean,
            default: true
          },

          other_options: {
              type:Array,
              default:function () {
                return []
              }
          },

          disabled_by_admin: {   // 表示需要根据当前登录用户是否为‘超级管理员’角色‘禁用/开放’的sys_code：若登录用户不为‘超级管理员’则‘disabled’为true；格式为：sys_code组成的字符串，以“,”分隔
              type: String,
              default: ""
          },

        },
        data() {
            let value = this.getValue()
            return {
                sys_code_loading:false,
                options: [{}],//下拉数据
                option_dict: {},//下拉数据字典
                sys_code_value: value
            }
        },
        model: {
            prop: 'data_value',
            event: 'data_value_change'
        },

        watch: {
          sys_code_list:{
            handler(data){
              this.setData(data)
            },
            deep: true
          },
            data_value(new_value, old_value) {
                this.sys_code_value = this.getValue(new_value)
            },
        },
        computed: {
            excude: function () {
                var data = {}
                this.excude_list.split(",").map((item) => {
                    data[item] = true
                })
                return data
            },
            disabled: function () {
                var data = {}
                this.disabled_list.split(",").map((item) => {
                    data[item] = true
                })
                return data
            },


        },
        mounted() {
          if(this.sys_code_list==null){
            this.getData()
          }else{
            this.setData(this.sys_code_list)
          }

        },
        methods: {

            getValue() {
                var value = ""
                if (this.sys_code_multiple) {
                    value = []
                    let data_value = this.data_value
                    if (data_value && data_value.trim()) {
                        data_value.split(",").map((item) => {
                            value.push(item)
                        })
                    }

                } else {

                    value = this.data_value
                }
                return value;
            },
            //选中事件
            change(value) {

                var selected_item = undefined
                var data_value = ""
                if (this.sys_code_multiple) {//多选
                    selected_item = []
                    value.map((item) => {
                        selected_item.push(this.option_dict[item])
                    })
                    data_value = value.join(",")
                } else {//单选
                    selected_item = this.option_dict[value]
                    data_value = value
                }
                this.$emit("sys_code_change", value, selected_item)
                this.$emit('data_value_change', data_value);
            },
          setData(data){
                var arr = data
                    //清空数据
                    var remove_list = []
                    arr.map((item) => {
                        //添加删除列表
                        if (this.excude.hasOwnProperty(item.sys_code)) {
                            remove_list.push(item)
                        }
                        //禁用
                        if (this.disabled.hasOwnProperty(item.sys_code)) {
                            item["disabled"] = true
                        }
                        //添加字典
                        this.option_dict[item.sys_code] = item

                    })
                    //删除
                    remove_list.map((item) => {
                        arr.remove(item)
                    })
                    this.options = arr.concat(this.other_options)
          },
            //获取数据
            async getData() {
                var data = {"page": 1, "size": 1000, "sys_code_type": this.sys_code_type}
                if(this.disabled_by_admin){
                  data.disabled_by_admin = this.disabled_by_admin
                }
                this.sys_code_loading = true
                var response = await API.GET("/omnis/system/sys_code/", data)
                this.sys_code_loading = false
                if (response && response.data) {
                    let arr = response.data.data
                    this.setData(arr)
                    // //清空数据
                    // var remove_list = []
                    // arr.map((item) => {
                    //     //添加删除列表
                    //     if (this.excude.hasOwnProperty(item.sys_code)) {
                    //         remove_list.push(item)
                    //     }
                    //     //禁用
                    //     if (this.disabled.hasOwnProperty(item.sys_code)) {
                    //         item["disabled"] = true
                    //     }
                    //     //添加字典
                    //     this.option_dict[item.sys_code] = item
                    //
                    // })
                    // //删除
                    // remove_list.map((item) => {
                    //     arr.remove(item)
                    // })
                    // this.options = arr


                }


            },

        }
    }
</script>



// WEBPACK FOOTER //
// sys_code_select.vue?17ab24cb